import { useMemo } from 'react'
import { find } from 'lodash-es'
import { useSystemManagerStore } from '@editorStores'

/**
 * Hook that provides a mapping from wall GUID to assembly name
 * @returns Record<string, string | undefined> - Map of wall GUID to assembly name (undefined if no assembly assigned)
 */
const useWallIdToAssembly = (): Record<string, Assembly | undefined> => {
  const assemblies = useSystemManagerStore(state => state.assemblies)
  const assemblyAssignment = useSystemManagerStore(state => state.assemblyAssignment)

  const wallIdToAssembly = useMemo(() => {
    return assemblyAssignment.reduce((collector, assignment) => {
      const assembly = find(assemblies, { guid: assignment.assembly_guid })
      if (assembly) {
        collector[assignment.element_guid] = assembly
      }
      return collector
    }, {} as Record<string, Assembly | undefined>)
  }, [assemblies, assemblyAssignment])

  return wallIdToAssembly
}

export default useWallIdToAssembly
